import type { Environment } from "./types.js";

function canonicalEnvironmentId(value: string): string {
  return value
    .split("/")
    .at(-1)!
    .toLowerCase()
    .replace(/^default-/, "");
}

/**
 * Find the authoritative Dataverse origin in the Flow environment-list
 * response. This is a fallback for tenants where BAP get-environment returns
 * 404 even though the same environment is Dataverse-backed.
 */
export function findDataverseInstanceUrl(
  environments: readonly Environment[],
  configuredEnvironmentId: string,
): string | undefined {
  const targetId = canonicalEnvironmentId(configuredEnvironmentId);
  const match = environments.find(
    (environment) => canonicalEnvironmentId(environment.name) === targetId,
  );
  if (!match) return undefined;

  const metadataUrl = match.properties.linkedEnvironmentMetadata?.instanceUrl;
  if (metadataUrl) return metadataUrl;

  const runtimeEntry = Object.entries(match.properties.runtimeEndpoints ?? {}).find(([name]) =>
    name.toLowerCase().includes("commondatamodel"),
  );
  return runtimeEntry?.[1];
}
